/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import { BaSeIcon } from '@base/react';
import CommonButton from '../../../shared/components/common-button/common-button';
import { useDisplay } from '../../hook/useDisplay';
import Modal from '../secrets/Modal';

import { cards10Caracteristicas } from '../../data/cards10Caracteristics';

import Slider from 'react-slick/lib/slider';
import {
  AlignButton,
  Container,
  ContainerMobile,
  ContainerText,
  Content,
  ContentItem,
  ContentItemMobile,
  ContentMobile,
  ContentText,
  RoundButton
} from './style';
import './style.css';

function EntrepreneurialCharacteristics() {
  const { isLargeDisplay } = useDisplay();
  const [linkSelected, setLinkSelected] = React.useState('');
  const [open, setOpen] = React.useState(false);

  function CustomArrow(props) {
    const { className, style, onClick, direction } = props;
    return (
      <RoundButton
        className={className}
        style={{ ...style, display: 'hidden' }}
        onClick={onClick}
      >
        <BaSeIcon
          name={`system/arrow-${direction}-s-line`}
          size="18"
          description="icon-lightulb-als"
          color="#0000c9"
        />
      </RoundButton>
    );
  }

  const CardButton = ({ item }) => (
    <CommonButton
      backgroundColor='#FFC700'
      foregroundColor='#0000C9'
      onClick={() => {
        setLinkSelected(item.linkVideo);
        setOpen(true);
      }}
    >
      Saiba mais
    </CommonButton>
  );

  React.useEffect(() => {
    const updateDivStyles = () => {
      const divs = document.querySelectorAll('li > div');
      const slickDots = document.querySelector('ul.slick-dots');

      if (slickDots) {
        slickDots.style.display = 'flex';
        slickDots.style.bottom = '-40px';
        slickDots.style.justifyContent = 'center';
        slickDots.style.alignItems = 'center';
        slickDots.style.gap = '15px';
        slickDots.style.padding = '0';
        slickDots.style.margingTop = '0';
      }

      divs.forEach((div) => {
        const parentLi = div.parentElement;

        if (parentLi.classList.contains('slick-active')) {
          div.style.backgroundColor = 'black';
          div.style.width = '30px';
          div.style.marginLeft = '10px';
          div.style.marginRight = '10px';
        } else {
          div.style.backgroundColor = 'rgb(139, 153, 167)';
          div.style.width = '15px';
          div.style.margin = '0 20px';
        }
      });
    };

    updateDivStyles();

    const observer = new MutationObserver(() => {
      updateDivStyles();
    });

    observer.observe(document.body, {
      childList: true,
      attributes: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);


  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    nextArrow: <CustomArrow direction="right" />,
    prevArrow: <CustomArrow direction="left" />,

    customPaging: (i) => (
      <div
        style={{
          height: '5px',
          borderRadius: 100,
          backgroundColor: '#8B99A7',
        }}
      >
        ‎
      </div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
          centerPadding: "50px",
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false
        }
      }
    ]
  };

  return (
    <Container id="3">
      <ContainerText>
        <p>
          Conheça as versões das <strong>10 características</strong> dos
          empreendedores de sucesso
        </p>
      </ContainerText>

      {
        isLargeDisplay() ? (
          <div style={{ padding: '0 20px' }}>
            <div className="slider-container">
              <Slider {...settings}>
                {cards10Caracteristicas.map((item) => (
                  <ContentItem number={item.id} key={item.id} >
                    <Content>
                      <ContentText>
                        <strong>{item.title}</strong>
                        <p>{item.desc}</p>
                      </ContentText>
                      <AlignButton>
                        <CardButton item={item} />
                      </AlignButton>
                    </Content>
                  </ContentItem>
                ))}
              </Slider>
            </div>
          </div>
        ) : (
          <ContainerMobile>
            {cards10Caracteristicas.map((item) => (
              <ContentItemMobile number={item.id} key={item.id}>
                <ContentMobile>
                  <ContentText>
                    <strong>{item.title}</strong>
                    <p>{item.desc}</p>
                  </ContentText>
                  <CardButton item={item} />
                </ContentMobile>
              </ContentItemMobile>
            ))}
          </ContainerMobile>
        )
      }


      <Modal open={open} link={linkSelected} onClose={() => setOpen(false)} />
    </Container >
  );
}

export default EntrepreneurialCharacteristics;
